// extracted by mini-css-extract-plugin
export var parcelRow = "_tx-0";